import type { RestoreOrgUserMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { RestoreOrgUserDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * Restore a previously archived non-SCIM org user. Symmetric counterpart to
 * useArchiveUser — refetch by operation name so the active observable matches
 * regardless of variables.
 */
export const useRestoreUser = createMutationHook({
  name: 'restoreUser',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.user.restoreUser.mutationOptions({ onSuccess }),
  mapInput: (userId: string) => ({ userId }),
  invalidate: (trpc) => [trpc.frontend.user.users.queryKey()],
  mapResponse: (result: {
    Id: string;
    Status: string;
  }): RestoreOrgUserMutation => ({
    restore_org_user: {
      __typename: 'OrgUserStatusTransitionOutput',
      Id: result.Id,
      Status: result.Status,
    },
  }),
  graphqlDocument: RestoreOrgUserDocument,
  graphqlVariables: (userId: string) => ({ userId }),
  evictFields: ['auth_user', 'auth_user_aggregate'],
  refetchQueries: ['GetAuthUsers'],
  awaitRefetchQueries: true,
});
